var exports = {
  "P": "GuildBoostBuyButton.module__label___OEw1SF",
  "q": "GuildBoostBuyButton.module__price___OEw1SF",
};

module.exports = exports;
